<template>
  <div id="dbSchema">
    <a-table
      :rowSelection="{
        selectedRowKeys: selectedRowKeys,
        onChange: onSelectChange
      }"
      :columns="columns"
      :dataSource="dbSchemaList"
      :pagination="Nopagination"
      :loading="loading"
      size="small"
      :locale="tabelText"
    >
      <template
        v-for="(item, index) in scopedSlotsArray"
        :slot="item"
        slot-scope="text"
      >
        <span :key="index">
          <a-tooltip placement="topLeft">
            <template slot="title">
              <span class="tableFontSize">{{
                text === "1" || text === true ? "Yes" : text === "0" || text === false ? "No" : text === "" ? "-" : text
              }}</span>
            </template>
            <div class="tableFontSize">
              {{text === "1" || text === true ? "Yes" : text === "0" || text === false ? "No" : text === "" ? "-" : text}}
            </div>
          </a-tooltip>
        </span>
      </template>
      <img slot="editMulti" slot-scope="text" @click="EditMultiLanguage(text)" class="sbxs" src="../../../assets/img/ss-edit.png"  width="22" height="22">
    </a-table>

    <!--editMulti-->
    <a-modal
            :title="$t('userlang.Language')"
            v-model="multiLanguageDialogVisable"
            width="60%"
            :maskClosable="false"
    >
      <template slot="footer">
        <a-button size="small" type="primary" @click="saveMultiLang">{{ $t('publicLang.Save') }}</a-button>
      </template>
      <a-form :form="multiForm" >
        <a-form-item :label="$t('userlang.englishName')"  v-bind="formItemLayout">
          <a-input size="small" style="width: 80%" v-model="englishName"/>
        </a-form-item>
        <a-form-item :label="$t('userlang.sumplifiedName')"  v-bind="formItemLayout">
          <a-input size="small" style="width: 80%" v-model="simplCnName"/>
        </a-form-item>
        <a-form-item :label="$t('userlang.traditionalName')"  v-bind="formItemLayout" >
          <a-input size="small" style="width: 80%" v-model="tradiCnName"/>
        </a-form-item>
        <a-form-item :label="$t('userlang.koreanName')"  v-bind="formItemLayout" >
          <a-input size="small" style="width: 80%" v-model="korName"/>
        </a-form-item>
        <a-form-item :label="$t('userlang.japaneseName')"  v-bind="formItemLayout" >
          <a-input size="small" style="width: 80%" v-model="jpName"/>
        </a-form-item>
        <a-form-item :label="$t('userlang.thaiName')"  v-bind="formItemLayout" >
          <a-input size="small" style="width: 80%" v-model="thName"/>
        </a-form-item>
      </a-form>
    </a-modal>

  </div>
</template>
<script>
import { mapState } from "vuex";
import ajax from "../../../api/ajax";
import api from "../../../api/url";
export default {
  data() {
    return {
      tabelText: {
        emptyText: "No record found"
      },
      Nopagination: false,
      selectedRowKeys: [],
      dbSchemaList: [],
      loading: false,
      scopedSlotsArray: [
        "TableName",
        "FieldName",
        "Mandatory",
        "FieldType",
        "FieldLength",
        "Decimal",
        "FKTab",
        "FKFieldName"
      ],
      multiLanguageDialogVisable: false,
      simplCnName:'',
      tradiCnName:'',
      englishName:'',
      korName:'',
      jpName: '',
      thName: '',
      schemaUid:'',
      formItemLayout: {
        labelCol: {
          xs: { span: 24 },
          sm: { span: 8 }
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 }
        }
      },
      multiForm: this.$form.createForm(this),
    };
  },

  computed: {
    columns() {
      return [
        {
          title: this.$t("generic.TableName"),
          dataIndex: "TableName",
          scopedSlots: { customRender: "TableName" }
        },
        {
          title: this.$t("generic.FieldName"),
          dataIndex: "FieldName",
          scopedSlots: { customRender: "FieldName" }
        },
        {
          width: 100,
          title: this.$t('userlang.Language'),
          scopedSlots: { customRender: "editMulti" }
        },
        {
          title: this.$t("generic.Mandatory"),
          dataIndex: "Mandatory",
          scopedSlots: { customRender: "Mandatory" }
        },
        {
          title: this.$t("generic.FieldType"),
          dataIndex: "FieldType",
          scopedSlots: { customRender: "FieldType" }
        },
        {
          title: this.$t("generic.FieldLength"),
          dataIndex: "FieldLength",
          scopedSlots: { customRender: "FieldLength" }
        },
        {
          title: this.$t("generic.Decimal"),
          dataIndex: "Decimal",
          scopedSlots: { customRender: "Decimal" }
        },
        {
          title: this.$t("generic.FKTable"),
          dataIndex: "FKTable",
          scopedSlots: { customRender: "FKTable" }
        },
        {
          title: this.$t("generic.FKFieldName"),
          dataIndex: "FKFieldName",
          scopedSlots: { customRender: "FKFieldName" }
        },
      ];
    },
    ...mapState(["uid"]) // 获取uid
  },
  created() {
    this.initTable();
  },
  watch: {
    uid(val) {
      if (val != "") {
        this.initTable();
      }
    }
  },
  methods: {
    initTable() {
      if (this.uid === "") {
        this.dbSchemaList = []
        return;
      }
      this.loading = true;
      let params = {
        uid: this.uid
      };
      ajax.get(api.GETSCHEMADETAIL, params).then(res => {
        this.dbSchemaList = res.data;
        this.loading = false;
        this.selectedRowKeys = [];
      });
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys;
      this.$emit("QuerydbSelectList", selectedRows);
    },
    EditMultiLanguage(text) {
      this.englishName = '';
      this.simplCnName = '';
      this.tradiCnName = '';
      this.korName = '';
      this.jpName = '';
      this.thName = '';
      this.schemaUid = text.schemaUid;
      let params = {//配置查询条件
        schemaUid: text.schemaUid,
      }
      ajax.get(api.GETMULTILANGUAGEBYSCHEAMA,params).then(res => {
        this.multiLanguageDialogVisable = true;
        if (res.code == 200) {
          let resData = res.data;
          if(resData != undefined && resData != null) {
            this.englishName = resData.englishName;
            this.simplCnName = resData.simplCnName;
            this.tradiCnName = resData.tradiCnName;
            this.korName = resData.korName;
            this.jpName = resData.jpName;
            this.thName = resData.thName;
          }
        } else {
          this.$customMessage.warning(res.msg);
        }

      });
    },
    saveMultiLang() {
      let params = {
        englishName: this.englishName,
        simplCnName: this.simplCnName,
        tradiCnName: this.tradiCnName,
        korName: this.korName,
        jpName: this.jpName,
        thName: this.thName,
        schemaUid: this.schemaUid
      };
      ajax.post(api.SAVEMULTILANGUAGEBYSCHEAMA, params).then(res => {
        if (res.code == 200) {
          this.$message.success(res.msg)
        } else {
          this.$customMessage.warning(res.msg);
        }
      });
    },
    clearSelectedRowKeys(){
      this.selectedRowKeys = []
    },
  }
};
</script>
<style lang="less">
#dbSchema {
  margin: 10px 0;
}
</style>
